import Footer from "../components/footer";
import Header from "../components/header"
import SideNavReSeller from "../components/sidenavReSeller"
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import PageHeader from "../components/pageHeader";



const MyWishlistReSeller = () => {

    let userInfo = JSON.parse(localStorage.getItem('admin-info'));
    const [dataWishList, setDataWishList] = useState([]);

        // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {

        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    useEffect(() => {
        debugger;
        fetchData('https://igapi.heuristticminds.com/api/WishList/Get-GetWishListByUserID?user_id='+ userInfo.user_id, setDataWishList);

    }, [dataWishList]);

    const columns = [
        {
            name: "Image",
            cell: (row) => <img className="m-2" src={`../images/products/full/${row.image}`} alt=" " width="80px" />,
            width: "180px"

        },
        {
            name: "Title",
            selector: (row) => row.productName,
            width: "200px"
        },
        {
            name: "Price",
            selector: (row) => row.price,
            width: "100px"
        },
        {
            name: "Artist",
            selector: (row) => row.artistName,
            width: "200px"
        },
        {
            name: "Date",
            // selector: (row) => row.createdOn,
            selector: (row) => new Date(row.createdOn).toLocaleDateString('en-GB',{day: 'numeric', month: 'short', year: 'numeric'}),

        },
        {
            name: "Action",
            cell: (row) => <><button className="btn btn-light me-2" onClick={() => onCartClick(row.id)}><i className="bi bi-cart-dash-fill"></i></button>
                <button className="btn btn-light" onClick={() => onDeleteClick(row.id)}><i className="bi bi-trash3-fill"></i></button></>
        },
    ];

    const onDeleteClick = async (id) => {
        debugger;
        const confirmed = window.confirm("Are you sure you want to Delete Wishlist Data?");
        if (!confirmed) {
            return; // If not confirmed, return early without deleting
        }
        try {
            const response = await fetch(`https://igapi.heuristticminds.com/api/WishList/Delete-DeleteWishListDetails?id=` + id, {
                method: 'DELETE'
            });
            if (response.ok) {
                // Refresh cart data if deletion was successful
                //const url = `https://igapi.heuristticminds.com/api/WishList/Get-GetWishListByUserID?user_id=`+userInfo.user_id;
                //fetchData(url, setDataWishList);
            } else {
                // Server responded with an HTTP status code outside the range 200-299
                console.error('Failed to delete cart item. Status:', response.status);
            }
        }
        catch (error) {

            console.error('Error saving form data:', error);
        }
        //bindgrid 
    };

    const onCartClick = async(id) =>{

        const confirmed = window.confirm("Are you sure you want to Move Wishlist Item to Cart ?");
        if (!confirmed) {
            return; // If not confirmed, return early without deleting
        }
        const flagData = {
            InsertedFlag : 0,
        };
        try {
            const response = await fetch(`https://igapi.heuristticminds.com/api/WishList/Add-MoveWishListtoCart?id=` + id, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(flagData), // Replace with your data
            });
            if (response.ok) {
                const data = await response.json();
                debugger;
                if(data.insertedFlag === 1)
                 {
                    const confirmed = window.confirm("Wishlist Item Moved to Cart Successfully ?");
                        if (!confirmed) {
                            return; // If not confirmed, return early without deleting
                        }
                }
                else{
                    const confirmed = window.confirm("Can not Move,  as same item is already in Cart !");
                        if (!confirmed) {
                            return; // If not confirmed, return early without deleting
                        }
                }
                
            } else {
                // Server responded with an HTTP status code outside the range 200-299
                console.error('Failed to delete cart item. Status:', response.status);
            }
        }
        catch (error) {
            console.error('Error saving form data:', error);
        }

    };

    return (
        <div>
            <Header />
            <div id="layoutSidenav">
                <SideNavReSeller />
                <div id="layoutSidenav_content">
                    <div>
                        <PageHeader name='Wishlist Data' icon='bi bi-suit-heart-fill' />
                        <div className="container-xl px-4">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="card mb-4 h-100">
                                        <div className="card-header">Wishlist</div>
                                        <div className="card-body">

                                        <div className="ps-2 pe-2">
                                                <DataTable
                                                    columns={columns}
                                                    data={dataWishList}
                                                    pagination
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default MyWishlistReSeller;